var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0335 44.0977L30 43.4739L28.9665 44.0977L14.4845 52.8385L18.3277 36.3644L18.602 35.1888L17.6895 34.3983L4.89233 23.3121L21.7391 21.8828L22.9408 21.7809L23.4114 20.6705L30 5.1252L36.5886 20.6705L37.0592 21.7809L38.2609 21.8828L55.1077 23.3121L42.3105 34.3983L41.398 35.1888L41.6723 36.3644L45.5155 52.8385L31.0335 44.0977Z",
    stroke: "#5F5D5F",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.39829fb44801749ad8ff86206c802366.svg";
export { ForwardRef as ReactComponent };